import React from 'react';
import QRCode from 'qrcode.react';

const panel_width = 800;

export default class ComicReader extends React.Component {
    render() {
        let { content, is_enough_egold } = this.props;
        if (is_enough_egold) {
            content = content.replace(/<\/?p>/g, '');
            content = JSON.parse(content);
        }
        return (
        <div>
        {is_enough_egold && content.pic.map((item, idx) => {
            return (
            <div key={idx} style={{
                width: `${panel_width}px`,
                height: `${panel_width * item.height / item.width}px`,
                backgroundImage: `url(${item.image})`,
			    backgroundSize: 'cover',
                backgroundPosition: 'center',
                margin: '0 auto',
            }}>          
            </div>
            );
        })}
        {is_enough_egold === false &&
            <div className="center" style={{
                textAlign: 'center', 
            }}>
                <div style={{
                    fontSize: '20px',
                    lineHeight: '28px',
                }}>下载万读APP，继续阅读精彩内容</div>
                <div style={{
                    marginTop: '20px', 
                }}>
                    <QRCode 
                        value="//t.10000read.com/attention/appdownload?from=pc_download"
                        size={106}
                    />
                </div>
                <div style={{
                    marginTop: '10px', 
                }}>扫一扫下载</div>
            </div>
        }
        </div>
        ); 
    }
}



// WEBPACK FOOTER //
// ./src/layout/book/read/comic_reader.js